function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#FF8096",
  cx: 10.5,
  cy: 10.5,
  r: 10.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.13 5.022)",
  fill: "#FF8096"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.326,
  cy: 9.544,
  r: 1.326
}), /*#__PURE__*/React.createElement("path", {
  d: "M.242 1.594C.106.939.54.408 1.212.408h.322c.672 0 1.097.54.954 1.196l-.975 4.44c-.1.456-.29.297-.426-.36l-.845-4.09z"
})));

function SvgRedError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg width='23' height='23' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(1 1)' fill='none' fill-rule='evenodd'%3E%3Ccircle stroke='%23FF8096' cx='10.5' cy='10.5' r='10.5'/%3E%3Cg transform='translate(9.13 5.022)' fill='%23FF8096'%3E%3Ccircle cx='1.326' cy='9.544' r='1.326'/%3E%3Cpath d='M.242 1.594C.106.939.54.408 1.212.408h.322c.672 0 1.097.54.954 1.196l-.975 4.44c-.1.456-.29.297-.426-.36l-.845-4.09z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
export { SvgRedError as ReactComponent };